@if (fields) {
  <div class="mt-2">
    <div class="checkbox-actions mb-2 lg">
      <div class="checbox-wrapper">
        @if (selectedItems != 0) {
          <div class="table-button-div-box">
            <div class="">
              <div class="selection-container">
                <a (click)="onAllChecked(false)" class="clear-selection active"><i class="fa fa-times"
                aria-hidden="true"></i></a>
                <span class="selected-items">
                  <b>{{selectedItems}}</b> Items selected
                </span>
              </div>
            </div>
            <div class="_checkbox-actions">
              <button type="button" (click)="onBulkActionClicked()" class="btn-with-icon-label">
                <i class="fa fa-check" aria-hidden="true"></i>
                <span>Consume Items</span>
              </button>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="w-100">
      <div class="col-12 table-container max-height-unset mb-0 p-0">
        <div class="table-responsive max-height-unset" style="max-height: 40vh;overflow: auto;">
          @if (!utilService.isMobile() || disableCardView) {
            <div>
              <table class="table mb-0" [ngClass]="actionClass?'table-actions':''">
                <thead>
                  <tr>
                    @for (field of fields; track field) {
                      @if (field.type == 'BulkAction') {
                        <th scope="col">
                          <label class="kx-check-wrapper for-grid m-0">
                            <input type="checkbox" class="checkbox" [checked]="checkedHeader"
                              [disabled]="checkedStatus(fields[0].condition)"
                              (change)="onAllChecked($event.target.checked,fields[0].condition)">
                            <span class="kx-check"
                            [ngClass]="checkedStatus(fields[0].condition)?'disabled':''"></span>
                          </label>
                        </th>
                      }
                      @if ((field.type == undefined || returnFieldType(field.type) || field.type == 'string') && !field.hidden && !field.hide) {
                        <th scope="col"
                          >
                        {{field.heading| translate | async}}</th>
                      }
                      @if (field.type == 'multiple_action' && !viewAction && !field.setting) {
                        <th scope="col"
                          ><i
                        class="fa fa-pencil-square-o"></i>
                      </th>
                    }
                    @if (field.type == 'action' && !viewAction && !field.setting) {
                      <th scope="col"><i
                      class="fa fa-pencil-square-o"></i>
                    </th>
                  }
                  @if (field.type == 'multiple_action' && !viewAction && field.setting) {
                    <th class="table-row-actions"
                      >
                      <i [popover]="popTemplate" class="fa fa-cog" container="body"
                        containerClass="tabelcontextualmenu table-header-menu" [outsideClick]="true"
                      placement="left top"></i>
                      <ng-template #popTemplate>
                        <div class="pl-3 p-2 p-dropdown-item">
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox"
                              (change)="HidetoggleVisibility($event.target.checked)"
                              [checked]="viewAll" class="custom-control-input"
                              id="customCheck" name="example1">
                            <label class="custom-control-label" for="customCheck">View
                            All</label>
                          </div>
                        </div>
                        @for (action of fields; track action) {
                          <div class="pl-3 p-2 p-dropdown-item">
                            @if (action.heading!=''&&action.heading) {
                              <div class="custom-control custom-checkbox"
                                >
                                <input type="checkbox" [checked]="action.selected"
                                  class="custom-control-input" id="{{action.heading}}"
                                  (change)="toggleVisibility($event,action)"
                                  [disabled]="action.disabled && !action.hidden">
                                <label class="custom-control-label"
                                  for="{{action.heading}}">{{action.heading | translate |
                                async}}</label>
                              </div>
                            }
                          </div>
                        }
                        <div class="pl-3 p-2 p-dropdown-item">
                          <a href="javascript:void(0)" (click)="resetDefaultConfig()"> Reset to
                          Default</a>
                        </div>
                      </ng-template>
                    </th>
                  }
                }
              </tr>
            </thead>
            <tbody>
              @for (value of data; track value; let i = $index) {
                <tr>
                  @for (field of fields; track field) {
                    @if (field.type == 'BulkAction') {
                      <td scope="row">
                        @if (checkCondition(field.condition,value)) {
                          <label class="kx-check-wrapper for-grid m-0"
                            >
                            <input type="checkbox" class="checkbox"
                              [checked]="selectedIndices[value.id]"
                              (click)="checkedItem($event.target.checked,i,value)">
                            <span class="kx-check"></span>
                          </label>
                        }
                      </td>
                    }
                    @if (field.type == 'switch') {
                      <td scope="row"
                        class="custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch">
                        @if (checkCondition(field.condition,value)) {
                          <input class="custom-control-input" id="customSwitch{{i}}" type="checkbox"
                            [checked]="selectedSwitch[value.id]"
                            (click)="checkedSwitch($event.target.checked,i,value)">
                        }
                        @if (checkCondition(field.condition,value)) {
                          <label class="custom-control-label" for="customSwitch{{i}}"
                            >
                          </label>
                        }
                      </td>
                    }
                    @if (field.type == 'icon') {
                      <td scope="row"><i class="{{field.icon}}"
                      aria-hidden="true" [ngStyle]="returnStyle(field,value)"></i>
                    </td>
                  }
                  @if (field.value) {
                    <td scope="row">{{field.value}}</td>
                  }
                  @if (!field.value && !field.type && !field.hidden) {
                    <td scope="row" [ngClass]="getClass(field,value)"
                    >{{value[field.name]}}</td>
                  }
                  @if ((field.type == 'string' || field.type == 'String' || field.type == 'boolean' || field.type == 'number') && !field.hidden ) {
                    <td scope="row"
                      >
                    {{value[field.name]}}</td>
                  }
                  <!-- renewal_date: render per-row (date display if serviceRequestId present, calendar otherwise) -->
                  @if (field.name === 'renewal_date' && (!field.cryoOnly || value.serviceType_code == 'cryopreservation') && !field.hidden
                    ) {
                    <td scope="row">
                      @if (value.serviceRequestId && value.confirm_order == true) {
                        {{ (value | mapvalue: field) ? (value | mapvalue: field | dateTimeFormat) : ''}}
                      } @else {
                        <input placeholder="Choose date" readonly style="background-color: #ffffff;" type="text"
                          ngxDaterangepickerMd class="form-control choose-date datepicker-search" placeholder="Choose date" showCancel="true" [singleDatePicker]="true" [ngModel]="value.defaultDate"
                          [minDate]="value.minDate" (datesUpdated)="onChangeDate($event,i)" [minDateNumber]="1" [disabled]="field.disable" [autoApply]="true" [showDropdowns]="true" required/>
                      }
                    </td>
                  }
                  @if (field.type == 'date' && !field.hidden && field.name != 'renewal_date') {
                    <td scope="row">
                      {{ (value | mapvalue: field) ? (value | mapvalue: field | dateTimeFormat) : ''}}
                    </td>
                  }
                  @if (field.type == 'monthYear' && !field.hidden) {
                    <td scope="row">
                    {{value[field.name] | date : 'MM/yyyy'}}</td>
                  }
                  @if (field.type === 'document') {
                    <td>
                      <app-document-viewer-with-thumbnail [documentId]="item[field.name]"
                        [config]="field" (click)="$event.stopPropagation()" [item]="item">
                      </app-document-viewer-with-thumbnail>
                    </td>
                  }
                  @if (field.type == 'datewithoutTime' && !field.hidden) {
                    <td scope="row">
                      {{ (value | mapvalue: field) ? (value | mapvalue: field | dateFormat) : ''}}
                    </td>
                  }
                  @if (field.type == 'currency' && !field.hidden && !field.class_conditions) {
                    <td scope="row">
                      <span>{{value.facility_id | BPcurrency}} </span>{{value[field.name]}}
                    </td>
                  }
                  @if (field.type == 'currency' && !field.hidden && field.class_conditions) {
                    <td scope="row" [ngClass]="getClass(field,value)">
                      <span>{{value.facility_id | BPcurrency}} </span>{{value[field.name]}}
                    </td>
                  }
                  @if (field.type == 'composite' && !field.hidden) {
                    <td scope="row">
                    {{getValue(field,value)}}</td>
                  }
                  @if (field.type == 'array' && !field.hidden) {
                    <td scope="row">
                    {{getArrayValue(field,value)}}</td>
                  }
                  @if (field.type == 'action' && !viewAction) {
                    <td scope="row">
                      @if (field.delete || field.delete == undefined) {
                        <div class="table-row-actions"
                          >
                          <i class="fa fa-trash" (click)="removeData(i)"></i>
                        </div>
                      }
                      @if (field.edit && showEdit(field.condition,value)) {
                        <div class="table-row-actions"
                          >
                          <i [ngClass]="field.edit-icon == undefined ? 'fa fa-pencil': 'fa fa-info'"
                          (click)="editData(value)"></i>
                        </div>
                      }
                    </td>
                  }
                  @if (field.type == 'multiple_action' && !viewAction) {
                    <td scope="row">
                      <div class="d-flex">
                        @for (a of field.array; track a) {
                          <ng-container class="">
                            <ng-template #toolTipView>{{toolTipInfo_view
                            |translate |async}}</ng-template>
                            @if ((a.delete || a.delete == undefined) && showEdit(a.condition,value) && checkpermision(a)) {
                              <div class="simple-data-table-action-icon"
                                [popover]="toolTipView" container="body" triggers="mouseenter:mouseleave"
                                placement="top">
                                <i class="fa fa-trash" (mouseover)="toolTipInfo(a)" (click)="removeData(i,a,value)"></i>
                              </div>
                            }
                            @if (a.cancel && value.show_cancel_button) {
                              <div class="simple-data-table-action-icon"
                                [popover]="toolTipView" container="body" triggers="mouseenter:mouseleave"
                                placement="top">
                                <i class="fa fa-times" (mouseover)="toolTipInfo(a)" (click)="cancelData(i)"></i>
                              </div>
                            }
                            @if (a.edit && showEdit(a.condition,value) && checkpermision(a) && a.edit-icon == undefined) {
                              <div class="simple-data-table-action-icon"
                                >
                                <i class="fa fa-pencil" (mouseover)="toolTipInfo(a)" (click)="editData(value)"></i>
                              </div>
                            }
                            @if (a.edit && showEdit(a.condition,value) && checkpermision(a) && a.edit-icon != undefined) {
                              <div class="simple-data-table-action-icon"
                                >
                                <img src="assets/images/template-i.svg" (click)="editData(value,a)"
                                  [popover]="toolTipView" container="body" triggers="mouseenter:mouseleave"
                                  [placement]="i==0?'left':'top'" (mouseover)="toolTipInfo(a)">
                              </div>
                            }
                            @if (a.print && showEdit(a.condition,value)) {
                              <div class="simple-data-table-action-icon" [popover]="toolTipView" container="body"
                                triggers="mouseenter:mouseleave" placement="top">
                                <i class="fa fa-print" (mouseover)="toolTipInfo(a)" (click)="print(a,value)"></i>
                              </div>
                            }
                            @if (a.template && showEdit(a.condition,value) && checkpermision(a)) {
                              <div class="simple-data-table-action-icon"
                                >
                                <img src="assets/images/template-form.svg"
                                  (click)="templateData({data:value,button:a})"
                                  [popover]="toolTipView" container="body" triggers="mouseenter:mouseleave"
                                  [placement]="i==0?'left':'top'" (mouseover)="toolTipInfo(a)">
                              </div>
                            }
                            @if (a.byPass && showEdit(a.condition,value) && checkpermision(a)) {
                              <div class="simple-data-table-action-icon"
                                >
                                <img src="assets/images/bypass-service.svg"
                                  (click)="rowData({data:value,button:a})"
                                  [popover]="toolTipView" container="body" triggers="mouseenter:mouseleave"
                                  [placement]="i==0?'left':'top'" (mouseover)="toolTipInfo(a)">
                              </div>
                            }
                            @if (a.viewTemplate && showEdit(a.condition,value) && checkpermision(a)) {
                              <div class="simple-data-table-action-icon"
                                >
                                <img src="assets/images/template-info.svg"
                                  (click)="templateData({data:value,button:a})"
                                  [popover]="toolTipView" container="body" triggers="mouseenter:mouseleave"
                                  [placement]="i==0?'left':'top'" (mouseover)="toolTipInfo(a)">
                              </div>
                            }
                          </ng-container>
                        }
                      </div>
                    </td>
                  }
                  @if (field.type == 'textbox' && !field.hidden) {
                    <td scope="row"><input
                      type="number" [pattern]="rolePermission.checkdecimalConfig() && field.typeValue=='decimal_currency'?preferenceService.currencyPattern():field.pattern" class="form-control td_number" [disabled]="field.disable"
                      (change)="onKey($event, i, field)" (input)="this.checkdecimal(field.name,i,$event)" [fieldType]="rolePermission.checkdecimalConfig() && field.typeValue=='decimal_currency'?'Double':''" [ngModel]="value[field.name]" min="0"
                      scrollOverlay>
                    </td>
                  }
                  @if (!field.hide && field.type == 'condition_tb') {
                    <td scope="row">@if (value.show_textbox) {
                      <input
                        type="number" [pattern]="rolePermission.checkdecimalConfig() && field.typeValue=='decimal_currency'?preferenceService.currencyPattern():field.pattern" class="form-control td_number" [disabled]="field.disable"
                        (change)="onKey($event, i, field)" (input)="this.checkdecimal(field.name,i,$event)" [fieldType]="rolePermission.checkdecimalConfig() && field.typeValue=='decimal_currency'?'Double':''" [ngModel]="value[field.name]" min="0"
                        scrollOverlay>
                    }
                  </td>
                }
                @if (field.type == 'editConfig_textbox' && !field.hidden) {
                  <td scope="row"><input
                    type="number" [pattern]="rolePermission.checkdecimalConfig() && field.typeValue=='decimal_currency'?preferenceService.currencyPattern():field.pattern" [ngClass]="getClass(field,value)" [disabled]="value.editablePrice"
                    (change)="onKey($event, i, field)" (input)="this.checkdecimal(field.name,i,$event)" [fieldType]="rolePermission.checkdecimalConfig() && field.typeValue=='decimal_currency'?'Double':''" [ngModel]="value[field.name]" min="0"
                    scrollOverlay>
                  </td>
                }
                @if (field.type == 'calender' && (!field.cryoOnly || value.serviceType_code == 'cryopreservation') && !field.hidden && field.name != 'renewal_date') {
                  <td scope="row"> <input placeholder="Choose date" readonly style="background-color: #ffffff;" type="text"
                    ngxDaterangepickerMd class="form-control choose-date datepicker-search" placeholder="Choose date" showCancel="true" [singleDatePicker]="true" [ngModel]="value.defaultDate"
                    [minDate]="value.minDate" (datesUpdated)="onChangeDate($event,i)" [minDateNumber]="1" [autoApply]="true" [showDropdowns]="true" required/>
                </td>
              }
              <!-- For renewal_date when service type is not cryopreservation -->
              @if (field.type == 'calender' && field.cryoOnly && !field.hidden && value.serviceType_code != 'cryopreservation') {
                <td>
                  &nbsp;
                </td>
              }
              @if (field.type == 'dropdown' && !field.hide) {
                <td scope="row">
                  @if ((!field.hide && !field.isDependent) || (field.isDependent && value.showDependent)) {
                    <select class="form-control" [ngModel]="value[field.name]" (ngModelChange)="changeDdVal($event,field,i)" [disabled]="field.disable">
                      <option value="">{{field.defaultKey}}</option>
                      @for (val of value[field.data]; track val) {
                        <option [value]="getDDOptionsVal(val, field)">
                        {{val[field.bindKey]}}</option>
                      }
                    </select>
                  }
                </td>
              }
              @if (field.type == 'checkbox' && !field.hidden) {
                <td scope="row">
                  <input type="checkbox" (change) = "CheckChanged($event.target.checked,i)" style="height: 15px;width: 15px;">
                </td>
              }
              @if (!field.hide && !field.hidden && field.type == 'inputSearch') {
                <td scope="row">
                  @if (field.name === 'performing_doctor' && !value.showInputSearch) {
                    <ng-template #performDoctorTip>{{toolTipInfo_view |translate |async}}</ng-template>
                    <span class="d-flex align-items-center">
                      @if (value.showSearchIcon) {
                        <div class="simple-data-table-action-icon mr-2"
                          [popover]="performDoctorTip" container="body" triggers="mouseenter:mouseleave" placement="top">
                          <i class="fa fa-search blue-color-text" (mouseover)="toolTipInfo({toolTip: 'Search & Assign Performing Doctor'})" (click)="togglePerformingDoctorSearch(i)"></i>
                        </div>
                      }
                      <span>{{ value[field.name] || '' }}</span>
                    </span>
                  } @else {
                    <ng-template #cancelSearchTip>{{toolTipInfo_view |translate |async}}</ng-template>
                    <span class="d-flex align-items-center">
                      @if (field.type == 'inputSearch' && value.showInputSearch) {
                        <input-search [placeholder]="'Search doctor'"
                          [_value]="value[field.name]" [data]="field.searchDoctorArgsForProcedure"
                        (patientResult)="setInputResult($event,i)"></input-search>
                      }
                      @if (field.name === 'performing_doctor' && value.showInputSearch) {
                        <button type="button" class="btn btn-link p-0 ml-2"
                          [popover]="cancelSearchTip" container="body" triggers="mouseenter:mouseleave" placement="top"
                          (mouseover)="toolTipInfo({toolTip: 'Cancel Search'})" (click)="cancelPerformingDoctorSearch(i)">
                        <i class="fa fa-times"></i>
                      </button>
                    }
                  </span>
                }
              </td>
            }
          }
        </tr>
      }
    </tbody>
  </table>
</div>
}
@if (utilService.isMobile() && !disableCardView) {
  <div>
    @for (value of data; track value; let i = $index) {
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 float-left card-mobile-padding"
        >
        <div #commonCardLayout class="card card-view default-view no-border-card">
          <div class="card-top-section">
            <div class="col-12 float-left p-top-section pl-2 pr-2 pt-2 appt-card-actions">
              @for (field of fields; track field) {
                <ng-container>
                  @if (field.type == 'multiple_action' && !viewAction) {
                    <div>
                      <div class="d-flex">
                        @for (a of field.array; track a) {
                          <span>
                            @if ((a.delete || a.delete == undefined) && showEdit(a.condition,value) && checkpermision(a)) {
                              <i
                              style="margin-right: 10px;" class="fa fa-trash" (click)="removeData(i,a,value)"></i>
                            }
                            @if (a.edit && showEdit(a.condition,value) && checkpermision(a)) {
                              <i
                                style="margin-right: 10px;" [ngClass]="a.edit-icon == undefined ? 'fa fa-pencil': 'fa fa-info'"
                              (click)="editData(value)"></i>
                            }
                            @if (a.template && showEdit(a.condition,value) && checkpermision(a)) {
                              <i class="simple-data-table-action-icon " style="margin-right: 10px;"
                                >
                                <img src="assets/images/template-form.svg" width="20px" height="20px"
                                  (click)="templateData({data:value,button:a})"
                                  [popover]="toolTipView" container="body" triggers="mouseenter:mouseleave"
                                  [placement]="i==0?'left':'top'" (mouseover)="toolTipInfo(a)">
                              </i>
                            }
                          </span>
                        }
                      </div>
                    </div>
                  }
                  @if (field.type == 'action' && !viewAction) {
                    <div>
                      @if (field.delete || field.delete == undefined) {
                        <div class="table-row-actions"
                          >
                          <i class="fa fa-trash" (click)="removeData(i)"></i>
                        </div>
                      }
                      @if (field.edit && showEdit(field.condition,value)) {
                        <div class="table-row-actions"
                          >
                          <i [ngClass]="field.edit-icon == undefined ? 'fa fa-pencil': 'fa fa-info'"
                          (click)="editData(value)"></i>
                        </div>
                      }
                    </div>
                  }
                </ng-container>
              }
            </div>
          </div>
          <div class="card-middle-section">
            <div class="col-12">
              <div class="row">
                @for (field of fields; track field) {
                  <div class="col-6 pl-1 pr-1">
                    @if (field.type == undefined || returnFieldType(field.type) || field.type == 'string') {
                      <span
                        >
                      {{field.heading| translate | async}}</span>
                    }
                    @if (field.type == 'icon') {
                      <p><i class="{{field.icon}}"
                      aria-hidden="true" [ngStyle]="returnStyle(field,value)"></i>
                    </p>
                  }
                  @if (field.value) {
                    <p>{{field.value}}</p>
                  }
                  @if (!field.value && !field.type && !field.hidden) {
                    <p [ngClass]="getClass(field,value)"
                      >
                    {{value[field.name]}}</p>
                  }
                  @if ((field.type == 'string' || field.type == 'String' || field.type == 'boolean' || field.type == 'number') && !field.hidden ) {
                    <p
                      >
                    {{value[field.name]}}</p>
                  }
                  @if (field.type == 'date' && !field.hidden) {
                    <p>
                      {{ (value | mapvalue: field) ? (value | mapvalue: field |
                    dateTimeFormat) : ''}}</p>
                  }
                  @if (field.type == 'monthYear' && !field.hidden) {
                    <p>
                    {{value[field.name] | date : 'MM/yyyy'}}</p>
                  }
                  @if (field.type == 'datewithoutTime' && !field.hidden) {
                    <p>
                      {{ (value | mapvalue: field) ? (value | mapvalue: field |
                    dateFormat) : ''}}</p>
                  }
                  @if (field.type == 'currency' && !field.class_conditions) {
                    <p>
                      <span>{{value.facility_id | BPcurrency}}
                      </span>{{value[field.name]}}
                    </p>
                  }
                  @if (field.type == 'currency' && field.class_conditions) {
                    <p [ngClass]="getClass(field,value)">
                      <span>{{value.facility_id | BPcurrency}}
                      </span>{{value[field.name]}}
                    </p>
                  }
                  @if (field.type == 'composite') {
                    <p>
                    {{getValue(field,value)}}</p>
                  }
                  <!-- <span *ngIf="field.type == 'multiple_action' && !viewAction">
                  <i class="fa fa-cog"></i>
                </span>
                <span *ngIf="field.type == 'action' && !viewAction">
                  <i class="fa fa-cog"></i>
                </span>
                -->
                @if (field.type == 'textbox' && !field.hidden) {
                  <p><input type="number"
                    class="form-control" [pattern]="rolePermission.checkdecimalConfig() && field.typeValue=='decimal_currency'?preferenceService.currencyPattern():field.pattern" [disabled]="field.disable" [fieldType]="rolePermission.checkdecimalConfig() && field.typeValue=='decimal_currency'?'Double':''"
                    (change)="onKey($event, i)" (input)="this.checkdecimal(field.name,i,$event)" [ngModel]="value[field.name]"
                  min="0" scrollOverlay></p>
                }
              </div>
            }
          </div>
        </div>
      </div>
      <!--for common card expand/collapse-->
      <div class="_common-card-expand-collapse"
        (click)="commonCardLayout.classList.toggle('h-full')">
        <img src="assets/images/icon-expand.svg" class="_card-expand" loading="lazy" alt="">
      </div>
    </div>
  </div>
}
</div>
}
</div>
</div>
</div>
</div>
}
